import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { Button } from "src/components/generic";
import { types } from "src/utils";
import { CheckCircle } from "lucide-react";

interface IActionableItemProps {
  title: string;
  description: string;
  subtitle?: string;
  url: string;
  status: boolean;
  buttonText?: string;
}

const ActionableItem: FunctionComponent<IActionableItemProps> = ({
  title,
  subtitle,
  description,
  url,
  status,
  buttonText,
}) => (
  <div
    className={`
      relative border-2 rounded-xl my-3 p-6 flex flex-col md:flex-row items-center justify-between gap-6
      transition-all duration-500 ease-out
      ${status ? "border-green-400 bg-green-50" : "border-primary/40 bg-white hover:border-primary hover:shadow-lg hover:scale-[1.02]"}
      group
    `}
  >
    {/* Animated shimmer background for incomplete items */}
    {!status && (
      <span className="absolute inset-0 bg-gradient-to-r from-primary/20 via-transparent to-primary/20 opacity-0 group-hover:opacity-40 blur-lg animate-shimmer-once pointer-events-none"></span>
    )}

    {/* Left content */}
    <div className="z-10">
      <h3 className="mb-2 font-bold text-lg text-gray-900">{title}</h3>
      {subtitle && <h4 className="mb-2 font-medium text-primary/90">{subtitle}</h4>}
            <p className="text-gray-700 text-sm leading-relaxed flex">
            {status && <span className="mr-2"><CheckCircle size={20} className="text-green-500" /></span>}
                {description}
            </p>
    </div>

    {/* Right action */}
    <div className="flex items-center justify-center md:justify-end w-full md:w-auto">
      {status ? (
        <div className="flex items-center gap-2 text-green-600 animate-pulse-once">
          <Button
            text="Completed"
            disabled
            styles="w-[170px]"
            theme={types.buttonTypes.BUTTON_THEME_TYPES.WHITE_INVERSE}
          />
        </div>
      ) : (
        <Link to={url} className="w-full md:w-fit">
          <Button
            text={buttonText || "Complete Now"}
            styles="w-full md:w-[170px] animate-float"
          />
        </Link>
      )}
    </div>
  </div>
);

export default ActionableItem;
